import type { PriceLine } from './price-line'

class PriceItemSpecification {
  priceLines: PriceLine[]
  totalPriceLine: PriceLine
}

const buildPriceItemSpecification = function (priceLines: PriceLine[], totalPriceLine: PriceLine): PriceItemSpecification {
  const priceItemSpecification = new PriceItemSpecification()
  priceItemSpecification.priceLines = priceLines
  priceItemSpecification.totalPriceLine = totalPriceLine
  return priceItemSpecification
}

export {
  PriceItemSpecification,
  buildPriceItemSpecification
}



// WEBPACK FOOTER //
// ./src/types/price-item-specification.js